import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  updateGuestFileSearchQuery,
  resetGuestFileSearchQuery
} from '../../../actions/components/file-search';

const initialState = {
  query: { q: '' }
};

const onChangeSearchQueryHandler = action => ({
  [action.toString()]: (state, { payload: query }) => set(`query`, query, state)
});

const onResetSearchQueryHandler = action => ({
  [action.toString()]: initialState
});

export default createReducer(initialState, {
  ...onChangeSearchQueryHandler(updateGuestFileSearchQuery),
  ...onResetSearchQueryHandler(resetGuestFileSearchQuery)
});
